import React, { useEffect, useState } from "react";
import { func, string, bool, number } from "prop-types";
import FontAwesome from "react-fontawesome";

// This will be the new search bar for the navbar, once replaced, delete the old search bar
// if the width is greater than
// Props:
// - searchFocused: boolean - will determine if the search bar is focused or not
// - setSearchFocus: function - will focus the search bar
// - currentSearchText: string - the current text in the search bar
// - handleSearchInput: function - will handle the search input
// - handleSubmit: function - will submit the search
// - onHandleAdvancedClick: function - if this prop is passed in then we will show a caret down icon that will execute this function when clicked

// TODO: Add test for this component
// things to test:
// - If the user hits enter the handleSubmit function should be called
// - If the user clicks the advanced button the onHandleAdvancedClick function should be called
// - If the user clicks the close button the setSearchFocus function should be called

const NavbarSearch = (props) => {
  const {
    searchFocused,
    setSearchFocus,
    currentSearchText,
    handleSearchInput,
    handleSubmit,
    onHandleAdvancedClick,
    disabled,
    className,
    debounceTime = 500,
  } = props;

  const [debouncedSearchText, setDebouncedSearchText] =
    useState(currentSearchText);

  // Debounce effect hook
  useEffect(() => {
    // Set up the debounce timer
    const timerId = setTimeout(() => {
      handleSearchInput(debouncedSearchText);
    }, debounceTime); // 500ms debounce time

    // Clear the timeout if the value changes (also on component unmount)
    return () => {
      clearTimeout(timerId);
    };
  }, [debouncedSearchText, debounceTime]);

  const handleKeyPress = (event) => {
    if (event.charCode === 13 && handleSubmit) {
      handleSubmit(debouncedSearchText);
    }
  };

  // Update the debounced search text and call the debounced handleSearchInput function
  const handleChange = (value) => {
    setDebouncedSearchText(value);
  };

  const getAdvancedButton = () =>
    onHandleAdvancedClick ? (
      <button
        type="button"
        className="navbar-search-advanced-button"
        onClick={onHandleAdvancedClick}
      >
        <FontAwesome name="caret-down" style={{ paddingLeft: "3px" }} />
      </button>
    ) : null;

  const getCloseButton = () =>
    searchFocused ? (
      <button
        type="button"
        onClick={() => setSearchFocus(!searchFocused)}
        className="navbar-search-close-button"
      >
        <FontAwesome name="times" className="navbar-search-close-icon" />
      </button>
    ) : null;

  const getClassName = () => {
    let baseClassName = className ?? "";

    if (searchFocused) {
      baseClassName += " search-focused";
    }

    return baseClassName;
  };

  return (
    <div className={getClassName()}>
      <div className="navbar-search-div">
        <input
          className="navbar-search-input"
          type="text"
          placeholder="Search candidates"
          maxLength="40"
          value={debouncedSearchText}
          onChange={(e) => handleChange(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={disabled}
        />
        {getAdvancedButton()}
        {getCloseButton()}
      </div>
      <div className="navbar-search-icon">
        <button
          type="button"
          style={{
            color: "#8b99ac",
            textDecoration: "underline",
            border: "none",
          }}
          onClick={setSearchFocus}
        >
          <FontAwesome
            name="search"
            style={{
              color: "light",
              fontSize: "18px",
              border: "none",
            }}
          />
        </button>
      </div>
    </div>
  );
};

NavbarSearch.propTypes = {
  searchFocused: bool,
  setSearchFocus: func.isRequired,
  currentSearchText: string.isRequired,
  handleSearchInput: func.isRequired,
  handleSubmit: func,
  onHandleAdvancedClick: func,
  disabled: bool,
  className: string,
  debounceTime: number,
};

export default NavbarSearch;
